import { unstable_useEnhancedEffect as useEnhancedEffect } from '@material-ui/utils';
export default useEnhancedEffect;